import "./AIReadiness.module.css";
import Header from "@/reusable_sections/Header";
import TheReadinessFramework from "./sections/TheReadinessFramework";
import StartYourAssessment from "./sections/StartYourAssessment";
import Footer from "@/reusable_sections/Footer";
export default function AIReadinessPage() {
  return <div>
      <Header />
      <TheReadinessFramework />
      <StartYourAssessment />
      <Footer />
    </div>;
}